import { createApi } from "@reduxjs/toolkit/query/react";

import { tomService } from "./restService";

export const dashboardApi = createApi({
  reducerPath: "dashboardApi",
  baseQuery: tomService({
    baseUrl: `${process.env.REACT_APP_BASE_URL}/company`,
  }),

  endpoints: builder => ({
    fetchDashboardFilter: builder.query({
      query: ({ company_id }) => ({
        url: `/${company_id}/dashboard-filters/`,
        method: "GET",
      }),
    }),
    fetchRegionFilter: builder.query({
      query: ({ company_id }) => ({
        url: `/${company_id}/regions/`,
        method: "GET",
      }),
    }),
    
    fetchFilterBasedOnBusinessUnit: builder.query({
      query: ({ company_id }) => ({
        url: `/${company_id}/business-unit/all`,
        method: "GET",
      }),
      
    }),
    fetchDashboardStats: builder.mutation({
      query: ({ company_id, body }) => ({
        url: `/${company_id}/dashboard-data/`,
        method: "POST",
        body,
      }),
    }),
  }),
});

export const { useFetchDashboardFilterQuery , useFetchRegionFilterQuery , useFetchDashboardStatsMutation , useFetchFilterBasedOnBusinessUnitQuery } = dashboardApi;